export type TierProps = {
  src: string;
  heading: string;
  content: string;
};

export function Tier({ src, heading, content }: TierProps) {
  return (
    <div className="flex flex-col gap-2 text-center items-center">
      <img src={src} className="size-32 bg-gray-200 rounded-full " />
      <h2 children={heading} />
      <p className="text-sm" children={content} />
    </div>
  );
}
